import styled from "styled-components"
import { device } from "breakpoints"
import { Link } from "gatsby"
import { ReactComponent as ArrowIcon } from "images/icons/breadcrumb-arrow.svg"

export const CategoriesContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  border-bottom: 2px solid #4ea3b3;
  padding-bottom: 10px;
  flex-wrap: wrap;
  margin-bottom: 25px;
  position: relative;

  @media ${device.desktop} {
    padding-bottom: 5px;
    margin-top: ${(props) => (props.categories ? "0" : "-7px")};
    margin-bottom: 40px;
  }
`

export const CategoriesLink = styled(Link)`
  font-weight: 500;
  font-size: 10px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  background: #4ea3b3;
  border-radius: 18px;
  padding: 10px 14px;
  margin-right: 10px;

  :hover {
    background: #3c8d9d;
  }

  @media ${device.desktop} {
    font-size: 12px;
    margin-bottom: 10px;
  }
`

export const HomeLink = styled(CategoriesLink)`
  position: absolute;
  left: 0;
  top: 4px;

  @media ${device.desktop} {
    top: 3px;
  }
`
